module.exports = __webpack_public_path__ + "static/media/apple-pay.72a0c212.svg";